module.exports = __webpack_public_path__ + "static/media/电脑自助打印.1397347.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SelfPrinting/电脑自助打印.mp4
// module id = l6/y
// module chunks = 10